import useStackAdapt from '@hooks/useStackAdapt';
import Button from '@stories/Elements/Forms/Buttons/Button';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

export interface Click2BuyProps {
  text?: string | null;
  stackAdaptTrackingCode?: string | null;
  articleNumber?: string | number | null;
  c2bAction?: string | null;
  onInit?: () => void;
  onHide?: () => void;
  onClick?: () => void;
}

const authorized_iframes = ['https://widget.clic2buy.com'];

const Click2Buy: FunctionComponent<Click2BuyProps> = (props) => {
  const { pushConversion } = useStackAdapt();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const calledOnInit = useRef<boolean>(false);
  const [style, setStyle] = useState<React.CSSProperties>({ display: 'none' });

  useEffect(() => {
    setStyle({ display: 'initial' });
    setStyle({ display: 'none' });
  }, [props.articleNumber]);

  useEffect(() => {
    if (!buttonRef.current || !props.onHide || !props.onInit) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (!props.onHide || !props.onInit) {
        return;
      }

      const style = buttonRef.current?.getAttribute('style') ?? '';

      if (style === '' && calledOnInit.current === false) {
        props.onInit();
        calledOnInit.current = true;

        if (props.c2bAction && props.c2bAction === 'open') {
          buttonRef.current?.click();
        }
      } else {
        props.onHide();
      }
    });

    observer.observe(buttonRef.current, { attributes: true, characterData: false, childList: false, subtree: false });
  }, [buttonRef.current]);

  useEffect(() => {
    if (window.c2btracking === true) {
      return;
    }

    window.c2btracking = true;

    window.addEventListener('message', (event) => {
      console.log('Received C2B event', event);
      if (authorized_iframes.indexOf(event.origin) > -1 && typeof event.data === 'object') {
        window.dataLayer = window.dataLayer || [];

        const customData = {
          ...event.data,
          event: event.data.action,
        };

        window.dataLayer!.push(customData);

        console.debug('Forwarding C2B event to GA', customData);
      }
    });
  }, []);

  if (!props.text) {
    return null;
  }

  return (
    <Button
      ref={buttonRef}
      text={props.text}
      theme="green"
      data-widget-element
      data-widget-reference={props.articleNumber}
      style={style}
      attributes={{
        'data-widget-element': '',
        'data-widget-reference': `${props.articleNumber}`,
      }}
      onClick={() => {
        pushConversion(props.stackAdaptTrackingCode);
        props.onClick && props.onClick();
      }}
    />
  );
};

export default Click2Buy;
